<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<span class="int_type_no_border mgr_10">
					<em class="lt_text">Item {{ headers.class }}</em>
					<ItemClassSelect v-model.trim="item_class" :showName="false" />
				</span>

				<span class="int_type_no_border mgr_10">
					<em class="lt_text">Vendor</em>
					<PartnerSelect v-model.trim="vendor_code" ph="Vendor Code" :showName="false" :vendorOnly="true" />
				</span>

				<span class="int_type_no_border mgr_10">
					<ItemSelectMulti v-model.trim="items_str" :active_only="false" :separator="separator" :resultsDisplay="obj => obj.item_code + ' | ' + obj.name" />
				</span>

				<a href="javascript: void(0);" class="search_bt" @click="search()">Search</a>
				<a href="javascript: void(0);" class="gray_bt" @click="reset()">Reset</a>
			</div>
		</div>
		<div>
			<p v-if="last_ship_price_arr && last_ship_price_arr.length" style="position: relative; height: 32px;">
				<span style="position: absolute; top: 4px; right: 4px;">
					<b class="lt_text">New Price</b>
					<span class="int_type_no_border mgr_10"><currency-input type="text" class="al_right tbl_int" :precision="3" v-model="new_price" autocomplete="off"/></span>
					<a href="javascript: void(0);" class="gray_bt" @click="applyNewPrice()">Apply</a>
				</span>
			</p>
			<div class="fixed-table-container-none-padding">
				<div class="table-wrapper" style="height: 95%">
					<table class="list_tbl sticky_list_tbl" v-columns-resizable id="">
						<thead>
							<tr>
								<th width="14%;">Item Code</th>
								<th>Item Name</th>
								<th width="7%;">Color</th>
								<th width="5%;">Unit Type</th>
								<th width="5%;" v-if="user.cost_view_yn == 'Y'">Cost($)</th>
								<th width="2%;"><input type="checkbox" v-model="all_checked" /></th>
								<th width="7%;">
									<a href="javascript: void(0);" @click="sort('partner_code')">Vendor Code{{ sortMark('partner_code') }}</a>
								</th>
								<th width="14%;">Vendor Name</th>
								<th width="7%;">SH No.</th>
								<th width="7%;">
									<a href="javascript: void(0);" @click="sort('app_date')">App. Date{{ sortMark('app_date') }}</a>
								</th>
								<th width="7%;">Last SH.Price($)</th>
								<th width="7%;">New Price($)</th>
								<th width="5%;">SH. History</th>
							</tr>
						</thead>
						<tbody>
							<template v-for="item in last_ship_price_arr">
								<template v-if="item.vendor_list && item.vendor_list.length">
									<tr v-for="(v, idx) in item.vendor_list" :key="item.item_id + '/' + idx">
										<template v-if="idx === 0">
											<td :rowspan="item.vendor_list.length">{{ item.item_code }}</td>
											<td :rowspan="item.vendor_list.length">{{ item.item_name }}</td>
											<td :rowspan="item.vendor_list.length" class="al_center">{{ item.color_code }}</td>
											<td :rowspan="item.vendor_list.length" class="al_center">{{ item.unit_type }}</td>
											<td :rowspan="item.vendor_list.length" class="al_right" v-if="user.cost_view_yn == 'Y'">{{ item.cost | toCurrency3 }}</td>
										</template>
										<!-- checkbox의 value를 객체(v)로 하는 경우, 객체(v) 속성의 값이 모두 같은 다른 객체(다른 item의 v)도 함께 참조됨.  -->
										<td class="al_center"><input type="checkbox" v-model="v.selected" /></td>
										<td>{{ v.vendor_code }}</td>
										<td>{{ v.vendor_name }}</td>
										<template v-if="v.sh_no">
											<td>
												<a class="tbl_pointer" herf="javascript: void(0);" @click="gotoShipment(v.sh_no)">{{ v.sh_dn }}</a>
											</td>
											<td class="al_center">{{ v.application_date }}</td>
										</template>
										<template v-else>
											<td colspan="2">By {{ v.upd_user }} In {{ v.upd_dt }}</td>
										</template>
										<td class="al_right">{{ v.price | toCurrency3 }}</td>
										<td><currency-input type="text" class="al_right tbl_int" :precision="3" v-model="v.new_price" autocomplete="off" /></td>
										<td><a href="javascript: void(0);" class="gray_bt" @click="showItemShipmentHistory(item.item_id, v.vendor_code)">History</a></td>
									</tr>
								</template>
								<template v-else>
									<tr :key="item.item_id">
										<td>{{ item.item_code }}</td>
										<td>{{ item.item_name }}</td>
										<td>{{ item.color_code }}</td>
										<td>{{ item.unit_type }}</td>
										<td v-if="user.cost_view_yn == 'Y'">{{ item.cost | toCurrency3 }}</td>
										<td colspan="8"></td>
									</tr>
								</template>
							</template>
						</tbody>
					</table>
				</div>
			</div>
		</div>
		<div class="view_bottom_bt">
			<a href="javascript:void(0);" type="button" class="search_bt" @click="save">Save</a>
		</div>

		<ItemShipmentHistoryByVendorModal v-if="show_modal && modal_name === 'shipment_history'" :headers="headers" :item_id="history_item_id" :vendor_code="history_vendor_code" @close="closeModal()" />
	</div>
</template>

<script>
import _ from 'lodash';
import { apiSelectLastShipmentPrice, apiUpdateLastShipmentPrice } from '@/api/purchase/purchase.js';

import ItemShipmentHistoryByVendorModal from '@/views/purchase/ItemShipmentHistoryByVendorModal.vue';
import ItemClassSelect from '@/components/common/ItemClassSelect.vue';
import ItemSelectMulti from '@/components/common/ItemSelectMulti';
import PartnerSelect from '@/components/common/PartnerSelect';
export default {
	data: () => ({
		last_ship_price_arr: [],

		items_str: '',
		item_class: '',
		vendor_code: '',

		all_checked: false,
		new_price: null,
		separator: ',',

		sort_key: '',
		sort_direction: '',

		show_modal: false,
		modal_name: null,

		history_item_id: null,
		history_vendor_code: null,
	}),
	components: {
		ItemClassSelect,
		ItemSelectMulti,
		PartnerSelect,
		ItemShipmentHistoryByVendorModal,
	},
	props: {
		headers: {
			type: Object,
			default: null,
		},
	},
	watch: {
		all_checked: {
			handler(checked) {
				this.last_ship_price_arr.forEach(lsp => {
					if (Array.isArray(lsp.vendor_list)) lsp.vendor_list.forEach(v => (v.selected = checked));
				});
			},
		},
	},
	computed: {
		user() {
			return this.$session.get('user');
		},
		company_id() {
			return this.user ? this.user.company_id : null;
		},
	},
	methods: {
		sortMark(sort_key) {
			if (this.sort_key == sort_key) return this.sort_direction == 'ASC' ? '▲' : '▼';
			else return null;
		},
		sort(sort_key) {
			if (this.sort_key == sort_key) {
				this.sort_direction = this.sort_direction == 'ASC' ? 'DESC' : 'ASC';
			} else {
				this.sort_key = sort_key;
				this.sort_direction = 'ASC';
			}
			this.search();
		},
		showItemShipmentHistory(item_id, vendor_code) {
			this.history_item_id = item_id;
			this.history_vendor_code = vendor_code;
			this.show_modal = true;
			this.modal_name = 'shipment_history';
		},
		closeModal() {
			this.history_item_id = null;
			this.history_vendor_code = null;
			this.show_modal = false;
		},
		gotoShipment(sh_no) {
			let routeData = this.$router.resolve({ name: 'shipmentDetail', params: { mode: 'detail' }, query: { sh_no } });
			window.open(routeData.href, '_blank');
		},
		async save() {
			const changed_list = _.cloneDeep(this.last_ship_price_arr);
			if (Array.isArray(changed_list)) {
				for (let i = 0; i < changed_list.length; i++) {
					const el = changed_list[i];
					if (Array.isArray(el.vendor_list)) {
						for (let j = 0; j < el.vendor_list.length; j++) {
							const v = el.vendor_list[j];
							if (typeof v.new_price === 'number') {
								v.upd_user = this.user ? this.user.user_id : null;
								v.price = v.new_price;
								v.sh_no = null;
								v.sh_dn = null;
							} else {
								el.vendor_list.splice(j, 1);
								j--;
							}
						}
					}

					if (!(Array.isArray(el.vendor_list) && el.vendor_list.length)) {
						changed_list.splice(i, 1);
						i--;
					}
				}
			}

			if (Array.isArray(changed_list) && changed_list.length) {
				const { data } = await apiUpdateLastShipmentPrice(changed_list);
				if (data > 0) {
					this.$toast.success('New Price Applied Successfully.');
					this.search();
				}
			} else {
				this.$toast.error('No Data has been Changed.');
			}
		},
		async search() {
			if (!this.items_str && !this.item_class && !this.vendor_code) {
				this.$toast.error('Please, Input Search Condition(s).');
				return;
			}

			const { data } = await apiSelectLastShipmentPrice(this.items_str ? this.items_str.split(this.separator) : [], this.item_class || '', this.vendor_code || '', this.sort_key || '', this.sort_direction || '');
			this.all_checked = false;
			this.new_price = null;
			if (Array.isArray(data)) {
				data.forEach(el => {
					// selected 및 new_price 속성 선언 및 초기화
					if (Array.isArray(el.vendor_list))
						el.vendor_list.forEach(v => {
							v.selected = this.all_checked;
							v.new_price = this.new_price;
						});
				});
			}
			this.last_ship_price_arr = data;
		},
		reset() {
			this.items_str = '';
			this.item_class = '';
			this.vendor_code = '';

			this.all_checked = false;
			this.new_price = null;
		},
		applyNewPrice() {
			if (typeof this.new_price !== 'number') {
				this.$toast.error('Please, Input New Price.');
				return;
			}

			let checkec_cnt = 0;
			this.last_ship_price_arr.forEach(lsp => {
				if (Array.isArray(lsp.vendor_list)) {
					lsp.vendor_list.forEach(v => {
						if (v.selected) {
							v.new_price = this.new_price;
							checkec_cnt++;
						}
					});
				}
			});

			if (!checkec_cnt) this.$toast.error('Check Row(s) to Be Applied New Price.');
			else this.new_price = null;
		},
	},
	created() {
		this.$store.commit('setSideIndex', 2);
		this.$store.commit('setSelectedMenu', 'nav_li_last_shipment_price');
		this.$store.commit('setSubTitle', 'Report -> Last Shipment Price');

		// sort 기준 초기화
		this.sort_key = 'app_date';
		this.sort_direction = 'DESC';
	},
};
</script>

<style></style>
